module.exports = __webpack_public_path__ + "media/animation_video.e555ef40.mp4";